import { Radio } from 'antd';

import { GROUP_BY_OPTIONS } from '../../constants';

/**
 * Radio group for selecting groupBy option.
 *
 * @param {Object} props
 * @param {Function} [props.onChange] - Callback when selection changes
 * @param {string} [props.value] - Currently selected value
 * @returns {React.ReactNode}
 */
export const GroupBy = ({ onChange, value, ...props }) => {
  return (
    <Radio.Group onChange={onChange} value={value} {...props}>
      {GROUP_BY_OPTIONS.map(option => (
        <Radio key={option.value} value={option.value}>
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  );
};

export default GroupBy;

